import { useState } from "react";
import InputDialog from "../../../../components/dialog";
import TransmedProcessSlide from "./slide";
import { useSetError } from "../../../generic-error";
import { useRevalidator } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import TransmedDistributionService from "../../../../service/transmed/process/distribution";
import TransmedRegistration from "../../../../dtos/transmed/process/registration/registration";

function TransmedProcessDistributed(props: {
  registration: TransmedRegistration;
  deadline: Date;
  passed: boolean;
}) {
  const [dialogCallback, setDialogCallback] = useState<
    (() => Promise<void> | void) | null
  >(null);

  const [loading, setLoading] = useState<boolean>(false);
  const revalidator = useRevalidator();
  const setErrorOnly = useSetError();
  const setError = (error: unknown) => {
    setErrorOnly(error);
    revalidator.revalidate();
  };

  const service = new TransmedDistributionService();

  return (
    <TransmedProcessSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "var(--gap-medium)",
      }}
    >
      <h3>Felicitări!</h3>
      <div>Ai fost repartizat în</div>
      <h1>{props.registration.preferred_lc?.city ?? "Necunoscut"}</h1>
      <div style={{ marginTop: "calc(var(--gap-xs) - var(--gap-medium))" }}>
        (
        {props.registration.preferred_lc_accomodation
          ? "cu cazare"
          : "fără cazare"}
        )
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "var(--gap-small)",
        }}
      >
        <button
          className="primary button"
          onClick={async () => {
            setError("");
            setLoading(false);

            try {
              await service.create.confirmation();
            } catch (error) {
              setError(error);
            } finally {
              revalidator.revalidate();
              setLoading(false);
            }
          }}
        >
          Confirmă-ți locul
        </button>
        <button
          className="primary button outlined"
          style={{ margin: 0, ...{ "--color": "red" } }}
          onClick={() =>
            setDialogCallback(() => async () => {
              setError("");
              setLoading(false);

              try {
                await service.delete.revoke(props.registration.id);
              } catch (error) {
                setError(error);
              } finally {
                revalidator.revalidate();
                setLoading(false);
              }
            })
          }
        >
          Renunță la loc
        </button>
        {props.registration.confirmed_lc !== null && (
          <button
            className="primary button outlined"
            onClick={async () => {
              setError("");
              setLoading(false);

              try {
                await service.update.keep(
                  props.registration.id,
                  props.registration.confirmed_lc!.id,
                  props.registration.confirmed_lc_accomodation
                );
                revalidator.revalidate();
              } catch (error) {
                setError(error);
              } finally {
                setLoading(false);
              }
            }}
          >
            Păstrează-ți locul la{" "}
            {props.registration.confirmed_lc?.city ?? "Necunoscut"}
          </button>
        )}
        {(loading || revalidator.state === "loading") && <CircularProgress />}
      </div>
      <div style={{ color: "red" }}>
        Termen confirmare loc:{" "}
        <b>{props.deadline.toLocaleTimeString("RO-ro")}</b>
      </div>
      <div className="label">
        {props.passed ? (
          <>
            <b style={{ color: "red" }}>Atenție!</b> Aceasta este ultima ta
            șansă de a-ți confirma locul. Dacă vei depăși acest interval orar
            îți vei pierde definitiv șansa de a participa la această ediție
            Transmed.
          </>
        ) : (
          <>
            <b>Atenție!</b> Dacă vei depăși acest interval orar, locul tău va fi
            atribuit unei alte persoane. Dacă vei depăși și intervalul orar
            imediat următor, îți vei pierde definitiv șansa de a participa la
            această ediție Transmed.
          </>
        )}
      </div>
      <InputDialog
        title="Renunță la loc"
        continue_label="Renunță la loc"
        abort_label="Întoarce-te"
        dialogCallback={dialogCallback}
        onClose={() => setDialogCallback(null)}
      >
        Această acțiune este ireversibilă! Vei pierde definitiv șansa de a
        participa la această ediție Transmed.
      </InputDialog>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessDistributed;
